import React from 'react';
import PropTypes from "prop-types";

import MindsetsJsSDK from "../../index";
import Autocomplete from "./Autocomplete";
import LessonDropdownItem from "./LessonDropdownItem";

function LessonDropdown(
    {
        default_value,
        placeholder = 'Code or name',
        container_class,
        input_class,
        show_add_always = false,
        label,
        label_class,
        renderAdd,
        onSelect,
        id,
        with_reset = false,
        disabled = false,
        match_dropdown_width = false,
        onReset
    }
) {
    function getLessons(q) {
        return MindsetsJsSDK().API.get('lessons', {q}).then(response => response.items);
    }

    return (
        <Autocomplete
            placeholder={placeholder}
            fetchItems={getLessons}
            onSelect={onSelect}
            label={label}
            label_class={label_class}
            renderItem={item => <LessonDropdownItem item={item}/>}
            default_value={default_value}
            persist_value={true}
            always_show_add={show_add_always}
            renderAdd={renderAdd}
            container_class={container_class}
            input_class={input_class}
            id={id}
            with_reset={with_reset}
            onReset={onReset}
            disabled={disabled}
            match_dropdown_width={match_dropdown_width}
        />
    );
}

LessonDropdown.propTypes = {
    default_value: PropTypes.string,
    placeholder: PropTypes.string,
    container_class: PropTypes.string,
    input_class: PropTypes.string,
    show_add_always: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.element,
    ]),
    label_class: PropTypes.string,
    renderAdd: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    with_reset: PropTypes.bool,
    disabled: PropTypes.bool,
    match_dropdown_width: PropTypes.bool,
    onReset: PropTypes.func
};

export default LessonDropdown;
